import { com } from '@eidu/web'
import EntityReference from './EntityReference'
import EntityWithLabel from '../../domain/entity/EntityWithLabel'
import EntityId = com.eidu.entity.EntityId

export type EntityReferenceValueProps = {
  id: EntityId | undefined
  entity: EntityWithLabel | null | undefined
  typeName: string | undefined
  loading?: boolean
}

const EntityReferenceValue = ({ id, entity, typeName, loading = false }: EntityReferenceValueProps) => (
  <EntityReference
    id={id}
    typeId={entity?.entity?.typeId}
    label={entity?.primaryLabelText}
    secondaryLabel={entity?.secondaryLabelText}
    typeName={typeName}
    state={loading || !id ? 'pending' : !entity ? 'unresolved' : 'resolved'}
  />
)

export default EntityReferenceValue
